import React from 'react';
import { Link } from 'react-router-dom';


export default function NotFound() {
    return <div>
        <img src={'https://cdn.dribbble.com/users/992274/screenshots/7392790/media/95483df50a0a3324c4cf9ccb1094b825.jpg'} />
        
    </div>;
}